import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useFeatures } from '@atc/features';

import { sendClick } from 'reaxl-analytics';

import {
    query,
    removeParameters,
} from '@/utilities/QueryStringUtil';
import { saveBAPListing as saveBAPListingAction } from '@/utilities/saveListing';
import saveRecentInventory from '@/utilities/saveRecentInventory';

import { savedInventoryDuck } from '@/ducks';

import { vdpResultsDuck } from '@/ducks/vdp';

import HeaderContentContainer from '@/containers/HeaderContentContainer';

let saveListingParam = query().saveListing;
// Removes the specified parameters from the page's query string
removeParameters('saveListing');

export function BuildAndPriceHeaderContainer() {
    const dispatch = useDispatch();
    const { preorder: [, { show_header_content: showHeaderContent } = {}] } = useFeatures(['preorder']);
    const listing = useSelector(vdpResultsDuck.selectors.getVdpActiveInventory);
    const savedListingIds = useSelector(savedInventoryDuck.selectors.getSavedInventoryIds);
    const isSaved = listing.id ? savedListingIds.includes(listing.id) : false;

    useEffect(() => {
        if (listing.id) {
            dispatch(saveRecentInventory(listing.id));
        }
    }, [dispatch, listing.id]);

    const autoSaveListing = () => {
        if (saveListingParam && !isSaved) {
            dispatch(saveBAPListingAction({
                event: {},
                listing,
                wasSaved: false,
                sendClick,
            }));
            saveListingParam = false;
        }
    };

    const saveListing = (data) => dispatch(saveBAPListingAction(data));

    return (
        <HeaderContentContainer
            onLoggedInStateReady={autoSaveListing}
            showHeaderContent={showHeaderContent}
            saveListing={saveListing}
        />
    );
}

export default React.memo(BuildAndPriceHeaderContainer);
